import FeatSDKV1 from 'api/version1';
import { createEffect } from 'effector';

export const getSitesMapByCountryIdFx = createEffect(
  FeatSDKV1.sitesMap.getSitesMapByCountryId,
);
